import { render, staticRenderFns } from "./coTransferAction.vue?vue&type=template&id=1a453adb&scoped=true"
import script from "./coTransferAction.vue?vue&type=script&lang=js"
export * from "./coTransferAction.vue?vue&type=script&lang=js"
import style0 from "./coTransferAction.vue?vue&type=style&index=0&id=1a453adb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a453adb",
  null
  
)

export default component.exports